import Vue from 'vue'
import Vue100vh from 'vue-div-100vh'
 
Vue.component('Vue100vh', Vue100vh)